import React, { useContext } from "react";
import { defaultFee } from "../../rbac-consts";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { default as AdminDefaultFeeDetailsContainer } from "./admin/DefaultFeeDetailsContainer";

const DefaultFeeDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={defaultFee.ADMIN}
      yes={() => (
        <AdminDefaultFeeDetailsContainer match={match} />
      )}
    />
  );
};

export default DefaultFeeDetailsWrapper;